
export default class ProductTabs extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onClickTabItem = this.onClickTabItem.bind(this);
    this.updateActiveBar = this.updateActiveBar.bind(this);
    this.onResize = this.onResize.bind(this);

    // privates
    this._node = this;
    this._tab_items = this._node.querySelectorAll(".tab-item");
    this._tabs = this._node.querySelectorAll(".tab");
    this._bar = this._node.querySelector(".active-bar");
    this._current_index = 0;

    // events
    window.addEventListener('resize', this.onResize);

    this._tab_items.forEach((el) => {
      el.addEventListener('click', this.onClickTabItem);
    });

    // init first tab item...
    this.onResize();
  }

  onResize() {
    if (window.innerWidth >= 1280) {
      this.updateActiveBar();
    }
  }

  /**
   * Handle tab item click.
   */
  onClickTabItem(e) {
    let target = e.currentTarget;

    if (!target.classList.contains('selected')) {
      let current_index = [...target.parentElement.children].indexOf(target);

      this._tab_items.forEach((el, index) => {
        if (current_index !== index) {
          el.classList.remove('selected');
        } else {
          el.classList.add('selected');
          this._current_index = current_index;
          this.updateActiveBar();
        }
      });

      this._tabs.forEach((el, index) => {
        if (current_index !== index) {
          el.classList.remove('current');
        } else {
          el.classList.add('current');
        }
      });
    }
  }

  updateActiveBar() {
    this._bar.style.width = `${this._tab_items[this._current_index].getBoundingClientRect().width}px`;
    this._bar.style.transform = `translateX(${this._tab_items[this._current_index].offsetLeft}px)`;
  }

  /**
   * Handle unmount.
   */
   disconnectedCallback() {
     window.removeEventListener('resize', this.onResize);
     this._tab_items.forEach((el) => {
       el.removeEventListener('click', this.onClickTabItem);
     });
  }
}
